﻿import { carPricing } from './car-pricing.js';
import { leaseTerms } from './lease-terms.js';
import { carImageSlider } from './car-slider.js';

(function () {
    const car = {};

    car.pricing = carPricing();
    car.terms = leaseTerms();
    if (!model.hasUsedCarImages) {
        car.slider = carImageSlider({
            img: '.slider-img',
            imgContainer: '.car-img',

            fullscreenBtn: '[data-slider-fullscreen]',
            fullscreenIcon: '[data-icon-fullscreen]',
            fullscreenIconExit: '[data-icon-fullscreen-exit]'
        });
        const sliderOptions = car.slider.options;
    }

    window.car = car;
})();